import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetListClassDrippingStatus } from '../../hooks/useGetListClassDrippingStatus';
import Collapse from 'src/shared/components/collapse';
import RenderClubAdmin from 'src/shared/components/renderClubAdmin/renderClubAdmin';
import { EmptyState } from './dripping/emptyState';
export function Dripping() {
    const { moduleId } = useParams();
    const [isOpen, setIsOpen] = useState(false);
    const [modalKey, setModalKey] = useState(0);
    const [currentDrippingKey, setCurrentDrippingKey] = useState('');
    const { t } = useTranslation();
    const { control, watch } = useFormContext();
    const { append, update, remove } = useFieldArray({ control, name: 'drippings' });
    const drippings = watch('drippings');
    const currentDripping = drippings.find((d) => d.key === currentDrippingKey) ?? null;
    const classesRequest = useGetListClassDrippingStatus(moduleId);
    const handleOpen = () => {
        setModalKey((prev) => prev + 1);
        setIsOpen(true);
    };
    const handleClose = useCallback(() => {
        setIsOpen(false);
        setCurrentDrippingKey('');
    }, []);
    const handleEdit = useCallback((drippingKey = '') => {
        setCurrentDrippingKey(drippingKey);
        handleOpen();
    }, []);
    const handleRemove = useCallback((drippingKey) => {
        const index = drippings.findIndex((dripping) => dripping.key === drippingKey);
        remove(index);
    }, [drippings, remove]);
    const handleSave = useCallback((dripping) => {
        const index = drippings.findIndex((dripping) => dripping.key === currentDrippingKey);
        if (index >= 0) {
            update(index, dripping);
        }
        else {
            append(dripping);
        }
        setIsOpen(false);
        setCurrentDrippingKey('');
    }, [drippings, update, append, currentDrippingKey]);
    return (_jsxs(Collapse, { startOpen: drippings.length > 0, children: [_jsx(Collapse.Header, { children: t('content.form.release_and_expiration.title') }), _jsxs(Collapse.Body, { children: [drippings.length === 0 && _jsx(EmptyState, { onClick: handleOpen }), drippings.length > 0 && (_jsx(RenderClubAdmin, { __name: "DrippingList", drippings: drippings, onEditClick: handleEdit, onRemoveClick: handleRemove, classes: classesRequest.data })), _jsx(RenderClubAdmin, { __name: "DrippingFormModal", isOpen: isOpen, onSave: handleSave, onClose: handleClose, drippings: drippings, dripping: currentDripping, classes: classesRequest.data }, modalKey)] })] }, drippings.length));
}
